/** The feature switches (specs/agents spec-v1.7): `agent.PlatformSwitches`, through `api/admin/platform-switches` on the account API. */
export type PlatformSwitchKey = 'agents' | 'intelligence' | 'micro-apps';

export interface PlatformSwitch {
  key: PlatformSwitchKey;
  enabled: boolean;
  /** Null until a person has changed the switch. */
  updatedAt: string | null;
  updatedBy: string | null;
  /** Businesses set to on, and set to off, whatever the platform says. */
  businessesOn: number;
  businessesOff: number;
}

/** One switch for one business: `api/admin/platform-switches/businesses/{businessId}`. */
export interface BusinessPlatformSwitch {
  key: PlatformSwitchKey;
  /** What the business gets. */
  enabled: boolean;
  platformEnabled: boolean;
  /** The business's own setting; null when it follows the platform. */
  override: boolean | null;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface PlatformSwitchCopy {
  key: PlatformSwitchKey;
  name: string;
  /** What the switch covers. */
  covers: string;
  /** What switching on does, and what switching off does; asked before either. */
  whenOn: string;
  whenOff: string;
}

/** Page order, and the words staff confirm against. */
export const PLATFORM_SWITCHES: readonly PlatformSwitchCopy[] = [
  {
    key: 'agents',
    name: 'Agents',
    covers: 'The website builder, AI images and the Agent Center.',
    whenOn: 'Merchants can start website builds and, with the add-on, create images. Work that was waiting carries on.',
    whenOff: 'Merchants cannot start website builds or create images, and the Agent Center is hidden. Work already queued waits until this is back on. Websites and images already made stay as they are.'
  },
  {
    key: 'intelligence',
    name: 'Plus Intelligence',
    covers: 'Reporting a problem, findings and proposals, and watches.',
    whenOn: '+Intelligence appears for those allowed to use it, and watches start again.',
    whenOff: '+Intelligence is hidden and watches pause. Cases stay stored.'
  },
  {
    key: 'micro-apps',
    name: 'Micro apps',
    covers: 'The Apps area: the catalog, the Studio and published apps.',
    whenOn: 'The Apps area appears, and published apps open again.',
    whenOff: 'The Apps area is hidden and published apps stop opening, including ones staff use every day. Nothing is deleted.'
  }
];
